import styled from "styled-components/macro";

const DivTextAlign = styled.div<{ align: "right" | "left" | "center" }>`
  text-align: ${(props) => props.align};
`;

export default DivTextAlign;
